import { render, staticRenderFns } from "./ruleAddOrEdit.vue?vue&type=template&id=740c671c&scoped=true"
import script from "./ruleAddOrEdit.vue?vue&type=script&lang=js"
export * from "./ruleAddOrEdit.vue?vue&type=script&lang=js"
import style0 from "./ruleAddOrEdit.vue?vue&type=style&index=0&id=740c671c&prod&scoped=true&lang=scss"
import style1 from "./ruleAddOrEdit.vue?vue&type=style&index=1&id=740c671c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740c671c",
  null
  
)

export default component.exports